import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-show-item',
    template: `
      <app-show-layout [strong]='strong' [label]="label">
        <span *ngIf="item">
          <div *ngIf="template" [innerHtml]=template(item)></div>
          <div *ngIf="!template">
            {{ item.getLabel() }}
          </div>
        </span>
        <span *ngIf="!item">
          <em class="text-secondary">Non presente</em>
        </span>
      </app-show-layout>
  `,
    standalone: false
})
export class ShowItemComponent {

  @Input() label;
  @Input() item;
  @Input() strong = true;
  @Input() template: () => string;
}
